import { Box } from "@mui/material";
import React, { useEffect } from "react";
import Sidebar from "../../components/SidebarLayout/Sidebar";
import { useDispatch, useSelector } from "react-redux";
import ManagementMasterContent from "../../components/Masters/ManagementMaster/ManagementMasterContent";

const ManagementMaster = () => {
  return (
    <>
      <Sidebar activeTab="Masters" title="Masters">
        <Box className="globalContainer_For_Content">
          <ManagementMasterContent />
        </Box>
      </Sidebar>
    </>
  );
};

export default ManagementMaster;
